<template>
  <v-container fluid>
    <v-card>
      <user-contacts-paginated-table :user="user">
      </user-contacts-paginated-table>
    </v-card>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import UserContactsTable from './components/UserContactsTable';
import UserContactsPaginatedTable from "./components/UserContactsPaginatedTable";

export default {
  components: {UserContactsPaginatedTable, UserContactsTable},
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'team',
      'hasMedicalAttributes',
      'user',
    ]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {

    },
  }
}
</script>
